<div class="db-one-month-free-demo">
  <div class="db-one-month-free-demo__header">
    <div class="back" (click)="onStepChange.emit('features')" *ngIf="showBackButton"><i class="db-icon db-icon-ds-arrow-small"></i></div>
    <h1 class="mb15">Try 10Web Pro functionality for free and launch your website</h1>
    <div class="db-period-switch-coupon mb25">
      <db-plan-period-switch [user]="user" [switcherColor]="'grey'"
                             [dontChangeSwitchValue]="true"
                             [uppercaseTitle]="false"
                             [hideBadge]="true"
                             [formControl]="periodSwitch"
                             [currentSubscription]="currentSubscription"></db-plan-period-switch>
      <span class="db-badge">Best value</span>
    </div>
  </div>
  <div class="db-one-month-free-demo__container">
    <div class="db-one-month-free-demo__content">
      <div class="db-one-month-free-demo__option">
        <div>
          <div class="db-one-month-free-demo__option-header">
            <h1>Personal</h1>
            <p>Best for individuals and businesses</p>
          </div>
          <div class="db-one-month-free-demo__option-price mt12">
            <h1>${{upgradeablePersonalSubscription?.plan?.planPrice / periodSwitch?.value}}<span>/mo</span></h1>
            <p>Billed {{periodSwitch?.value === 12 ? 'annually' : 'monthly'}}</p>
          </div>
          <div class="db-one-month-free-demo__plan-info mt8">
            <p *ngFor="let planInfo of personalPlan " class="mt5">
              <img src="assets/images/icons/checkmark-white-blue.svg" class="mr8"/>{{planInfo}}
            </p>
            <a class="ds-btn-blue rectangle mt20" [ngClass]="{'ds-btn-l': !isMobile, 'ds-btn-m': !!isMobile }"
               (click)="chooseSubscr(this.upgradeablePersonalSubscription); onStepChange.emit('checkout')">
              <span>{{(!!isMobile ? 'try for 7 days' : 'try 10Web pro for 7 days') | lowerCaseSpecificWords}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="db-one-month-free-demo__option agency">
        <div>
          <div class="db-one-month-free-demo__option-header">
            <h1>Agency</h1>
            <p>Best for agencies and freelancers</p>
          </div>
          <div class="db-one-month-free-demo__option-price mt12">
            <h1>${{upgradeableEnterpriseSubscription?.plan?.planPrice / periodSwitch?.value}}<span>/mo</span></h1>
            <p>Billed {{periodSwitch?.value === 12 ? 'annually' : 'monthly'}}</p>
            <b class="mt23 mb4">All in personal plan plus</b>
          </div>
          <div class="db-one-month-free-demo__plan-info mt8">
            <p *ngFor="let planInfo of agencyPlan " class="mt5">
              <img src="assets/images/icons/checkmark-white-blue.svg" class="mr8"/>{{planInfo}}
            </p>
            <a class="ds-btn-blue rectangle mt44" [ngClass]="{'ds-btn-l': !isMobile, 'ds-btn-m': !!isMobile }"
               (click)="chooseSubscr(this.upgradeableEnterpriseSubscription); onStepChange.emit('checkout')">
              <span>{{(!!isMobile ? 'try for 7 days' : 'try 10Web pro for 7 days') | lowerCaseSpecificWords}}</span>
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
